"use client";

import dynamic from "next/dynamic";

import type { SiteChatSetup } from "@/services/ai-site-chat-service";

const SiteChatWidget = dynamic(() => import("./site-chat-widget").then((module) => module.SiteChatWidget));

export function SiteChatWidgetLoader({ setup }: { setup: SiteChatSetup }) {
  return <SiteChatWidget setup={setup} />;
}
